<template>
  <div class="min-h-screen flex w-full bg-slate-950 font-sans selection:bg-indigo-500 selection:text-white">

    <!-- Lado Izquierdo: Panel de Marca IA Neurals (Desktop) -->
    <div class="hidden lg:flex w-1/2 bg-slate-950 relative overflow-hidden flex-col justify-between p-14 text-white border-r border-slate-800/60">

      <!-- Grid de Fondo Tecnológico -->
      <div class="absolute inset-0 bg-[linear-gradient(to_right,#1e293b15_1px,transparent_1px),linear-gradient(to_bottom,#1e293b15_1px,transparent_1px)] bg-[size:4rem_4rem] [mask-image:radial-gradient(ellipse_60%_50%_at_50%_50%,#000_70%,transparent_100%)] pointer-events-none"></div>

      <!-- Luces difuminadas de fondo (Efecto Glow) -->
      <div class="absolute top-[-15%] left-[-15%] w-[500px] h-[500px] bg-indigo-600/20 rounded-full blur-[140px] pointer-events-none animate-pulse"></div>
      <div class="absolute bottom-[-15%] right-[-15%] w-[500px] h-[500px] bg-violet-600/20 rounded-full blur-[140px] pointer-events-none"></div>

      <!-- Header: Logo Neurals Blanco Puro -->
      <div class="relative z-10 flex items-center justify-between">
        <div class="flex items-center gap-3">
          <img
            src="@/assets/img/logo_neurals_nuevo.png"
            alt="Neurals Logo"
            class="h-9 w-auto object-contain brightness-0 invert drop-shadow-[0_0_12px_rgba(255,255,255,0.3)] transition-transform hover:scale-105"
          />
        </div>

      </div>

      <!-- Centro: Propuesta de Valor & Showcase -->
      <div class="relative z-10 max-w-lg space-y-8 my-auto">
        <div class="space-y-4">
          <div class="inline-flex items-center gap-2 px-3 py-1 rounded-lg bg-slate-900 border border-slate-800 text-xs text-slate-300 font-medium">
            <Sparkles class="w-3.5 h-3.5 text-indigo-400" />
            <span>Automatización Inteligente Multicanal</span>
          </div>
          <h2 class="text-3xl xl:text-4xl font-extrabold tracking-tight text-white leading-tight">
            Potencia la atención de tu empresa con <span class="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 via-purple-300 to-pink-400">Agentes Inteligentes Autónomos</span>.
          </h2>
          <p class="text-slate-400 text-base leading-relaxed">
            Centraliza WhatsApp, resuelve consultas en segundos y cierra ventas sin fricción mediante modelos LLM conectados a tu catálogo.
          </p>
        </div>


      </div>

      <!-- Footer Izquierdo -->
      <div class="relative z-10 flex items-center justify-between text-xs text-slate-400 pt-6 border-t border-slate-900">
        <p>© {{ currentYear }} Neurals Platform.</p>
        <div class="flex gap-4 text-slate-400">
          <span class="hover:text-slate-400 transition-colors">Desarrollado por <a href="https://therealdevs.pro/">The Real Devs Pro</a></span>
        </div>
      </div>
    </div>

    <!-- Lado Derecho: Formulario de Inicio de Sesión -->
    <div class="w-full lg:w-1/2 flex items-center justify-center p-6 sm:p-12 relative bg-slate-900/40">

      <!-- Fondo difuminado móvil -->
      <div class="lg:hidden absolute inset-0 overflow-hidden pointer-events-none">
        <div class="absolute -top-40 -right-40 w-80 h-80 bg-indigo-500/10 rounded-full blur-3xl"></div>
      </div>

      <div class="w-full max-w-md space-y-8 bg-slate-900/80 backdrop-blur-xl p-8 sm:p-10 rounded-3xl border border-slate-800 shadow-2xl shadow-black/50 relative z-10">

        <!-- Logo en Celular / Tablets (Blanco) -->
        <div class="lg:hidden flex justify-center mb-2">
          <img
            src="@/assets/img/logo_neurals_nuevo.png"
            alt="Neurals Logo"
            class="h-9 w-auto object-contain brightness-0 invert drop-shadow"
          />
        </div>

        <div class="text-center lg:text-left space-y-1.5">
          <h1 class="text-2xl sm:text-3xl font-bold text-white tracking-tight">Bienvenido de nuevo</h1>
          <p class="text-slate-400 text-sm">Ingresa a tu consola para gestionar tus agentes e instancias.</p>
        </div>

        <!-- Alerta de Error -->
        <div v-if="errorMessage" class="p-4 rounded-xl bg-red-500/10 border border-red-500/20 flex items-center gap-3 text-red-400 animate-fade-in text-sm">
          <AlertCircle class="w-5 h-5 flex-shrink-0 text-red-400" />
          <span class="font-medium">{{ errorMessage }}</span>
        </div>

        <form @submit.prevent="handleLogin" class="space-y-5">

          <!-- Usuario / Correo -->
          <div class="space-y-1.5">
            <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider">Usuario o Correo</label>
            <div class="relative group">
              <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                <User class="h-4 w-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
              </div>
              <input
                v-model="form.email"
                type="text"
                required
                autocomplete="username"
                class="w-full pl-10 pr-4 py-3 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                placeholder="admin@empresa.com"
              >
            </div>
          </div>

          <!-- Contraseña -->
          <div class="space-y-1.5">
            <div class="flex items-center justify-between">
              <label class="text-xs font-semibold text-slate-300 uppercase tracking-wider">Contraseña</label>
            </div>
            <div class="relative group">
              <div class="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none">
                <Lock class="h-4 w-4 text-slate-400 group-focus-within:text-indigo-400 transition-colors" />
              </div>
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                required
                autocomplete="current-password"
                class="w-full pl-10 pr-11 py-3 bg-slate-950/60 border border-slate-800 rounded-xl text-sm text-slate-100 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500/40 focus:border-indigo-500 transition-all no-uppercase"
                placeholder="••••••••"
              >
              <button
                type="button"
                @click="showPassword = !showPassword"
                tabindex="-1"
                class="absolute inset-y-0 right-0 pr-3.5 flex items-center text-slate-400 hover:text-slate-300 transition-colors cursor-pointer"
              >
                <component :is="showPassword ? EyeOff : Eye" class="h-4 w-4" />
              </button>
            </div>
          </div>

          <!-- Opción de Recordar -->
          <div class="flex items-center justify-between pt-1">
            <label class="flex items-center gap-2 cursor-pointer select-none group">
              <input
                id="remember-me"
                v-model="form.remember"
                type="checkbox"
                class="w-4 h-4 rounded bg-slate-950 border-slate-800 text-indigo-600 focus:ring-indigo-500/40 focus:ring-offset-0 focus:outline-none cursor-pointer"
              >
              <span class="text-xs text-slate-400 group-hover:text-slate-300 transition-colors">Recordar sesión</span>
            </label>
          </div>

          <!-- Botón de Iniciar Sesión -->
          <button
            type="submit"
            :disabled="isLoading"
            class="w-full flex justify-center items-center py-3.5 px-4 rounded-xl text-sm font-bold text-white bg-gradient-to-r from-indigo-600 via-indigo-500 to-purple-600 hover:from-indigo-500 hover:to-purple-500 focus:outline-none focus:ring-2 focus:ring-indigo-500/50 shadow-lg shadow-indigo-600/25 disabled:opacity-60 disabled:cursor-not-allowed transition-all duration-200 active:scale-[0.98] cursor-pointer"
          >
            <Loader2 v-if="isLoading" class="w-5 h-5 animate-spin mr-2" />
            <span v-else class="flex items-center gap-2">
              Acceder al Panel <ArrowRight class="w-4 h-4" />
            </span>
          </button>
        </form>

        <!-- Redirección al Signup -->
        <div class="pt-2 text-center text-xs text-slate-400 border-t border-slate-800/60">
          ¿Aún no tienes una cuenta empresarial?
          <router-link to="/signup" class="font-bold text-indigo-400 hover:text-indigo-300 transition-colors ml-1 inline-flex items-center">
            Regístrate aquí
          </router-link>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { User, Lock, Eye, EyeOff, ArrowRight, Loader2, AlertCircle, Sparkles } from 'lucide-vue-next';
import apiClient from '@/api/client';
import { SecureStorage } from '@/utils/secureStorage';

const router = useRouter();
const currentYear = new Date().getFullYear();

// Estados reactivos
const form = ref({
  email: '',
  password: '',
  remember: false
});

const showPassword = ref(false);
const isLoading = ref(false);
const errorMessage = ref('');

const handleLogin = async () => {
  isLoading.value = true;
  errorMessage.value = '';

  try {
    const payload = {
      username: form.value.email,
      password: form.value.password
    };

    const response = await apiClient.post('/login', payload);
    const data = response.data;
    const token = data.token;

    if (token) {
      localStorage.setItem('neurals_token', token);

      const userToSave = {
        id: data.id,
        username: data.username,
        email: data.email,
        full_name: data.full_name,
        role_id: data.role_id,
        company: data.company,
        photo_url: data.photo_url,
        is_premium: data.is_premium
      };

      SecureStorage.setItem('neurals_user', userToSave);
      router.push('/client/dashboard');
    } else {
      throw new Error('No se recibió token de acceso del servidor');
    }

  } catch (error) {
    console.error('Error de autenticación Neurals:', error);
    if (error.response && error.response.status === 401) {
      errorMessage.value = 'Credenciales incorrectas. Verifica tu acceso.';
    } else {
      errorMessage.value = 'Error de conexión con el servidor de Neurals.';
    }
  } finally {
    isLoading.value = false;
  }
};
</script>

<style scoped>
@keyframes fade-in-up {
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fade-in {
  animation: fade-in-up 0.25s ease-out forwards;
}
</style>